export const PERMISSIONS = {
  USER_PROJECTS_READ: "user.projects.read",
  USER_NOTIFICATIONS_READ: "user.notifications.read",
  USER_NOTIFICATIONS_MARK_AS_READ: "user.notifications.mark",
  USER_NOTIFICATIONS_DELETE: "user.notifications.delete",
  USER_INVITATIONS_ACCEPT: "user.invitations.accept",
  USER_INVITATIONS_DECLINE: "user.invitations.decline",
  PROJECT_CREATE: "project.create",
  PROJECT_READ: "project.read",
  PROJECT_UPDATE: "project.update",
  PROJECT_DELETE: "project.delete",
  PROJECT_MEMBERS_READ: "project.members.read",
  PROJECT_MEMBERS_DELETE: "project.members.delete",
  PROJECT_MEMBERS_ROLE_UPDATE: "project.members.role.update",
  PROJECT_MEMBERS_LEAVE: "project.members.leave",
  PROJECT_INVITATIONS_READ: "project.invitations.read",
  PROJECT_INVITATIONS_CREATE: "project.invitations.create",
  PROJECT_INVITATIONS_DELETE: "project.invitations.delete",
  PROJECT_TICKETS_CREATE: "project.tickets.create",
  PROJECT_TICKETS_READ: "project.tickets.read",
  PROJECT_TICKETS_UPDATE: "project.tickets.update",
  PROJECT_TICKETS_DELETE: "project.tickets.delete",
  PROJECT_TICKET_HISTORY_READ: "project.ticket.history.read",
  PROJECT_TICKET_COMMENTS_READ: "project.ticket.comments.read",
  PROJECT_TICKET_COMMENTS_CREATE: "project.ticket.comments.create",
  PROJECT_TICKET_COMMENTS_UPDATE: "project.ticket.comments.update",
  PROJECT_TICKET_COMMENTS_DELETE: "project.ticket.comments.delete",
  PROJECT_TICKET_COMMENTS_DELETE_OWN: "project.ticket.comments.delete.own",
  PROJECT_TICKET_COMMENTS_LIKE: "project.ticket.comments.like",
  PROJECT_TAGS_READ: "project.tags.read",
} as const;
